import { faHeartBroken } from "@fortawesome/duotone-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  FlexBox,
  JoonUIColor,
  Loader,
  SessionBillingPeriod,
  SPACING,
  Typography,
  UserRole,
  WarningTriangleIcon,
} from "@joonapp/web-shared"
import { CellContext } from "@tanstack/react-table"
import { useId } from "react"
import { useMemo } from "react"
import { Tooltip } from "react-tooltip"

import { useCoachingSubscriptionQuery } from "../../../networking/coachingGroups/queries"
import { CoachingSubscriptionStatus } from "../../../types"
import { ClientTableData } from "../../../types/misc"
import { formatDate } from "../../../util/dates"

const CycleEndCell = (
  info: CellContext<ClientTableData, SessionBillingPeriod[] | null>
) => {
  const tooltipId = useId()
  const client = useMemo(
    () =>
      info.row.original.coachingGroup?.profiles.find(
        (p) => p.role === UserRole.CLIENT
      ),
    [info.row.original.coachingGroup]
  )
  const { data: clientSubscriptionInfo, isLoading } =
    useCoachingSubscriptionQuery(client?.user.id)

  const isSetToCancel = clientSubscriptionInfo?.set_to_cancel

  if (isLoading)
    return <Loader size={12} thickness={2} color={JoonUIColor.icon.neutral} />

  return (
    <FlexBox
      direction="row"
      gap={SPACING.space1}
      data-tooltip-id={tooltipId}
      wrap={false}
      align="center"
    >
      {clientSubscriptionInfo?.status ===
        CoachingSubscriptionStatus.EXPIRED && (
        <WarningTriangleIcon color={JoonUIColor.semantic.alert} size={12} />
      )}
      {isSetToCancel && (
        <FontAwesomeIcon
          icon={faHeartBroken}
          color={JoonUIColor.semantic.alert}
          fontSize={12}
        />
      )}
      <Typography variant="bodySmall" textAlign="left">
        {formatDate(
          new Date(clientSubscriptionInfo?.active_period_end_date || 0),
          "MMM D"
        )}
      </Typography>
      {clientSubscriptionInfo?.status ===
        CoachingSubscriptionStatus.EXPIRED && (
        <Tooltip id={tooltipId}>
          <Typography variant="bodySmall" color={JoonUIColor.text.inverted}>
            Payment failed
          </Typography>
        </Tooltip>
      )}
      {isSetToCancel && (
        <Tooltip id={tooltipId}>
          <Typography variant="bodySmall" color={JoonUIColor.text.inverted}>
            Expires on{" "}
            {formatDate(
              new Date(clientSubscriptionInfo?.active_period_end_date || 0),
              "MMM D"
            )}
          </Typography>
        </Tooltip>
      )}
    </FlexBox>
  )
}

export default CycleEndCell
